;
define("header_mini_cart_item_cell.tpl", function(){});

